<template>
  <div class="container mt-4">
    <h2>編輯產品</h2>
    <form >
      <b-card no-body>
        <b-tabs card>
          <b-tab title="基本資料" active>
            <b-card-text>

              <div class="form-group">
                <label for="name">產品名稱</label>
                <input v-model="product.name" type="text" class="form-control" id="name" required>
              </div>

              <div class="form-group">
                <label for="categoryId">分類</label>
                <div class="input-group">
                  <select v-model="product.categoryId" class="form-control" id="categoryId">
                    <option v-for="category in categories" :key="category" :value="category">
                      {{ category }}
                    </option>
                  </select>
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="addNewCategory">
                      新增分類
                    </button>
                  </div>
                </div>
              </div>



              <div class="form-group">
                <label for="price">價格</label>
                <input v-model.number="product.price" type="number" class="form-control" id="price" step="1" required>
              </div>

<!--              <div class="form-group">-->
<!--                <label for="memberPrice">會員價格</label>-->
<!--                <input v-model.number="product.memberPrice" type="number" class="form-control" id="memberPrice" step="1">-->
<!--              </div>-->

              <div class="form-group">
                <label for="option">選項（每行一個選項）</label>
                <textarea
                    v-model="optionsText"
                    class="form-control"
                    id="option"
                    rows="5"
                    @input="updateOptions"
                ></textarea>
              </div>

              <div class="form-group form-check">
                <input v-model="product.isActive" type="checkbox" class="form-check-input" id="isActive">
                <label class="form-check-label" for="isActive">啟用</label>
              </div>

<!--              <div class="form-group">-->
<!--                <label for="sortOrder">排序</label>-->
<!--                <input v-model.number="product.sortOrder" type="number" class="form-control" id="sortOrder" step="1" required>-->
<!--              </div>-->

              <b-card-text>
                <div class="form-group">
                  <label for="description">商品規格</label>
                  <MyCkEditor v-model="product.spec" height="300px" width="800px" ></MyCkEditor>
                </div>
              </b-card-text>

            </b-card-text>
          </b-tab>
          <b-tab title="圖片">
            <b-card-text>
              <div v-if="id">
                <label for="option">產品圖片</label>
                <ListEditImageProduct :datas="imageJsonObject" :product-id="id" ></ListEditImageProduct>
              </div>
              <div v-else>
                請先儲存後，再上傳圖片
              </div>

            </b-card-text>
          </b-tab>
          <b-tab title="商品說明">
            <b-card-text>
              <div class="form-group">
                <label for="description">商品說明</label>
                <MyCkEditor v-model="product.description" height="600px" width="800px" ></MyCkEditor>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="注意事項">
            <b-card-text>
              <div class="form-group">
                <label for="description">注意事項</label>
                <MyCkEditor v-model="product.memoText" height="600px" width="800px" ></MyCkEditor>
              </div>

            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>

      <button type="button" class="btn btn-primary" @click="saveProduct">保存</button>
      <button type="button" class="btn btn-info" @click="goback">回上一頁</button>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";
import MyCkEditor from "@/taylorCommon/component/MyCkEditor.vue";
import ListEditImageProduct from "@/views/fireGods/component/ListEditImageProduct.vue";

export default {
  components: {ListEditImageProduct, MyCkEditor},
  data() {
    return {
      id:"",
      product: {
        id: null,
        name: '',
        categoryId: '',
        description: '',
        status: '',
        price: 0,
        memberPrice: 0,
        sortOrder: 0,
        isActive: true,
        spec: '',
        memo: '',
        memoText:'',
        option: '',
        imageJson: '',
      },
      categories: [],
      imageJsonObject: {
        BannerFileName:"",
        Images:[
        ]
      },
      optionsText: '',
    };
  },
  mounted() {
    this.id=this.$route.query.id
    this.loadProduct();
    this.loadCategories();
  },
  methods: {
    updateOptions() {
      // 將多行文本轉換回分號分隔的字符串
      this.product.option = this.optionsText.split('\n').filter(option => option.trim() !== '').join(';');
    },
    async loadProduct() {
      let that=this;
      // 假設產品ID從路由參數中獲取
      const productId = this.id;

      if (productId){
        apiFireGodsec.api_Admin_ECProduct_Get(productId).then((data)=>{
          that.product = data.data.data;
          // 將選項字符串轉換為多行文本
          that.optionsText = that.product.option.split(';').join('\n');

          if (that.product.imageJson !=null && that.product.imageJson!=""){
            that.imageJsonObject=JSON.parse(that.product.imageJson);
          }

        })
      }


    },
    async loadCategories() {
      let that=this;
      apiFireGodsec.api_Admin_ECProduct_GetCategories().then((data)=> {
        that.categories = data.data.data;
      })
    },
    async handleFileUpload(event) {
      const files = event.target.files;
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('images[]', files[i]);
      }
      try {
        const response = await axios.post(`/api/firegodsec/Admin_ECProduct_UploadImages`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        debugger // eslint-disable-line
        this.images = [...this.images, ...response.data];
      } catch (error) {
        console.error('上傳圖片失敗', error);
      }
    },
    addNewCategory() {
      const newCategory = prompt('請輸入新分類名稱');
      if (newCategory) {
        this.categories.push(newCategory);
        this.product.categoryId = newCategory;
      }
    },
    goback() {
      // this.$router.go(-1);
      this.$router.push({ name: 'ECProductList' });
    },
    async saveProduct() {
      try {
        //validate by client
        if (!this.product.name) {
          alert('請輸入產品名稱');
          return;
        }
        if (!this.product.categoryId) {
          alert('請選擇分類');
          return;
        }
        if (this.product.price <=0) {
          alert('請輸入價格');
          return;
        }

        // if (this.product.memberPrice <=0) {
        //   alert('會員價格不能小於0');
        //   return;
        // }



        if (!this.product.spec) {
          alert('請輸入商品規格');
          return;
        }

        // if (this.images.length === 0) {
        //   alert('請上傳產品圖片');
        //   return;
        // }


        // 確保在保存之前更新選項
        this.updateOptions();

        if (this.imageJsonObject.Images.length>0 && this.imageJsonObject.BannerFileName==""){
          alert('請指定一張封面圖片');
          return;
        }

        this.product.imageJson=JSON.stringify(this.imageJsonObject);

        apiFireGodsec.api_Admin_ECProduct_Save(this.product).then((data)=> {  // eslint-disable-line
          alert('產品保存成功');
          //CC
          this.$router.replace({ name: 'TemporaryPage' }).then(() => {
            this.$router.push({ name: 'ECProductDetail', query: { id: data.data.data.id } });
          });

          // debugger // eslint-disable-line
          // window.location.href = this.$router.resolve({
          //   name: 'ECProductDetail',
          //   query: { id: data.data.data.id }
          // }).href;
        })

        // await axios.put(`/api/products/${this.product.id}`, this.product);
        // if (this.bannerImageIndex !== -1) {
        //   await axios.post(`/api/products/${this.product.id}/set-banner`, {
        //     imageId: this.images[this.bannerImageIndex].id
        //   });
        // }
        // alert('產品保存成功');
      } catch (error) {
        console.error('保存產品失敗', error);
        alert('保存產品失敗');
      }
    }
  }
};
</script>

<style scoped>
/* 可以在這裡添加自定義樣式 */
</style>
